import { render, staticRenderFns } from "./sendMenu.vue?vue&type=template&id=9158aa1a&scoped=true"
import script from "./sendMenu.vue?vue&type=script&lang=js"
export * from "./sendMenu.vue?vue&type=script&lang=js"
import style0 from "./sendMenu.vue?vue&type=style&index=0&id=9158aa1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9158aa1a",
  null
  
)

export default component.exports